import './index.less'
import Legend from '@/assets/images/AssociationPage/legend.svg'
import Events, { IEvents } from './Events'
import Graph, { IGraph } from './Graph'
import { useCallback, useEffect, useState } from 'react'
//关联图谱
import { getGraph } from '@/server'
import { useAppSelector } from '@/hooks'

export function AssociationPage({ name }: { name: string }) {
  const token = useAppSelector((state) => state.login.token)
  const [events, setEvents] = useState<IEvents['data']>([])
  const [id2name, setId2name] = useState<IEvents['id2name']>({})
  const [id2painter, setId2painter] = useState<IGraph['id2painter']>({})
  const [filterIds, setFilterIds] = useState<number[]>([])
  const [centerId, setCenterId] = useState<number>(-1) // 中心人物id

  useEffect(() => {
    if (name === '佚名' || name === '') return
    getGraph(name, token).then((res) => {
      if (res.status === 200) {
        const { id, events, id2name, id2painter } = res.data
        setCenterId(Number(id))
        setEvents(events)
        setId2name(id2name)

        setId2painter(
          Object.keys(id2painter).reduce(
            (acc, cur) => ({
              ...acc,
              [cur]: {
                data: id2painter[cur],
                sum: id2painter[cur] ? id2painter[cur].reduce((a, c) => a + c, 0) : 0
              }
            }),
            {}
          )
        )
      }
    })
  }, [name])

  const setFilterId = useCallback(
    (source, target) => {
      if (source === filterIds[0] && target === filterIds[1]) {
        setFilterIds([])
      } else {
        setFilterIds([source, target])
      }
    },
    [filterIds]
  )

  return (
    <div id='graph-panel'>
      <div className='graph-header'>
        <h2>作者社交关系</h2>
        <img src={Legend} alt='legend' />
      </div>

      <Graph
        data={events}
        id2name={id2name}
        id2painter={id2painter}
        centerId={centerId}
        setCenterId={setCenterId}
        filterIds={filterIds}
        setFilterId={setFilterId}
      />
      <Events data={events} id2name={id2name} centerId={centerId} filterIds={filterIds} />
    </div>
  )
}
